import { useEffect, useRef, useState } from "react";
import { useGameContext } from "./Hook/GameContext";
import { GameRNGHeader, GameRNGWrapper } from "./Style/GameStyles";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
import { insetState } from "../../../recoil/inset";
import { useRecoilValue } from "recoil";
pdfjs.GlobalWorkerOptions.workerSrc =
  "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";

export const GameRNG = () => {
  const { setIsRng } = useGameContext();
  const [numPages, setNumPages] = useState(0);
  const [pageWidth, setPageWidth] = useState(600);
  const containerRef = useRef<HTMLDivElement>(null);
  const inset = useRecoilValue(insetState);

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        setPageWidth(Math.min(containerWidth, 800));
      }
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };

  return (
    <GameRNGWrapper isApp={inset}>
      <GameRNGHeader onClick={() => setIsRng(false)}>닫기</GameRNGHeader>
      <div className="content">
        · RNG(Random Number Generator)는 게임에서 생성된 데이터를 분석하여
        시스템 조작 가능 여부를 판별하고, 서비스 중인 게임에 게임사의 인위적인
        개입이 없음을 검증하는 국제 공인 인증 방식입니다.
        <br />
        <br />· iTech Labs는 전 세계 온라인 게임 시스템의 인증 및 품질 보증
        테스트를 전문으로 수행하는 세계 최대 규모의 공인 테스트 연구소입니다. 각
        게임별 RNG 인증을 획득한 러너러너는 플레이어들에게 공정하고 신뢰할 수
        있는 게임 환경을 제공하는 것을 최우선으로 합니다.
      </div>
      <div ref={containerRef}>
        <Document
          file="/image-web/game/RNG.pdf"
          onLoadSuccess={onDocumentLoadSuccess}
          loading={
            <div style={{ textAlign: "center", padding: "40px" }}>
              <div>PDF 로딩 중...</div>
            </div>
          }
          error={
            <div style={{ textAlign: "center", padding: "40px", color: "red" }}>
              PDF를 불러올 수 없습니다.
            </div>
          }
        >
          <Page
            pageNumber={numPages}
            width={pageWidth}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        </Document>
      </div>
    </GameRNGWrapper>
  );
};
